import React from "react";
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";
import { update_solved, update_favourite } from "../../actions/questionActions";

const TableC = (props) => {
  const filterFn = (data) => {
    let visible = true;
    if (!data.title) {
      data.title = "";
    }
    if (!data.title.toLowerCase().includes(props.searchString)) {
      visible = false;
    }

    if (props.topic !== "All" && data.topic !== props.topic) {
      visible = false;
    }

    if (props.topic === "Favourites" && data.favourite) {
      visible = true;
    }

    if (props.solved !== "All" && data.solved !== props.solved) {
      visible = false;
    }
    return visible;
  };

  const update_solved = (id, solved) => {
    props.update_solved(id, solved);
  };

  const renderTable = (data) => {
    return data.map((data) => {
      return filterFn(data) ? (
        <tr key={data.id} className={data.solved ? "bg-success-cust" : ""}>
          <th scope="col" className="font-weight-normal">
            {data.id}
          </th>
          <th scope="col" className="font-weight-normal">
            {data.topic}
          </th>
          <th scope="col">
            <span onClick={() => props.update_favourite(data.id)}>
              {data.favourite ? (
                <span className="fav pointer">
                  <Icon name="star" color="yellow" size="large" />
                </span>
              ) : (
                <span className="fav">
                  <Icon className="pointer" style={{ opacity: "10%" }} name="star outline" size="large" />
                </span>
              )}
            </span>
          </th>
          <th scope="col" className="font-weight-light">
            <a href={data.link} rel="noreferrer" target="_blank" className="font-weight-normal">
              {data.title}
            </a>
          </th>
          <th scope="col">
            <button
              className={data.solved ? "btn btn-outline-success" : "btn btn-outline-dark"}
              onClick={() => {
                update_solved(data.id, data.solved);
              }}
            >
              {data.solved ? "success" : "solved"}
            </button>
          </th>
        </tr>
      ) : null;
    });
  };

  return (
    <div>
      <table className="table table-dark">
        <thead className="thead-dark">
          <tr>
            <th scope="col">Sno</th>
            <th scope="col">Topic</th>
            <th scope="col">Fav</th>
            <th scope="col">Title</th>
            <th scope="col">Solved</th>
          </tr>
        </thead>
        <tbody>{renderTable(props.data)}</tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => {
  return {
    data: store.questions.question_list,
    loading: store.questions.loading,
    topic: store.questions.topic,
    favourites: store.questions.favourites,
    solved: store.questions.solved,
    searchString: store.questions.searchString,
  };
};

export default connect(mapStateToProps, { update_solved, update_favourite })(TableC);

// const renderTable2 = (data) => {
// 	return data.map((data) => {
// 		return filterFn(data) ? (
// 			<Table.Row key={data.id} positive={data.solved}>
// 				<Table.Cell color="red">{data.id}</Table.Cell>
// 				<Table.Cell>{data.topic}</Table.Cell>
// 				<Table.Cell>
// 					<a href={data.link} rel="noreferrer" target="_blank">
// 						{data.title}
// 					</a>
// 					<span onClick={() => props.update_favourite(data.id)}>
// 						{data.favourite ? (
// 							<span className="fav pointer">
// 								<Icon name="star" color="yellow" size="large" />
// 							</span>
// 						) : (
// 							<span className="fav">
// 								<Icon className="pointer" style={{ opacity: "10%" }} name="star outline" size="large" />
// 							</span>
// 						)}
// 					</span>
// 				</Table.Cell>
// 				<Table.Cell collapsing textAlign="center">
// 					<Checkbox
// 						checked={data.solved}
// 						onClick={() => {
// 							update_solved(data.id, data.solved);
// 						}}
// 					/>
// 				</Table.Cell>
// 			</Table.Row>
// 		) : null;
// 	});
// };
